// extracted by mini-css-extract-plugin
export default {"baseLoader":"baseLoader--ebgpG"};